import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/user";


class UserService {

  edituser(data:any) {
    //console.log(data)
    return axios
      .put(API_URL, data)
      .then(response => {
        return response;
      });
  }

  adduser(data:any) {
    //console.log(data)
    return axios
      .post(API_URL, data)
      .then(response => {
        return response.data;
      });
  }
  userExist(shortcut:string, id : number){
    return axios
      .post(API_URL + '/exist', {shortcut: shortcut, id : id})
      .then(response => {
        return response.data;
      });
  }

  deleteuser(userId:number) {
    //console.log(query)
    return axios
      .delete(API_URL + '/'+userId)
      .then(response => {
        return response.data;
      });
  }

  
  getusergrouplookup() {
    return axios
      .get(API_URL + "/usergroups-lookup" , {
        params:{
           
        }
      })
      .then(response => {
        return response;
      });
  }


  getusers(query:string) {
    return axios
      .get(API_URL + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }


  setpassword(username: string, newpass: string, confirmpass: string) {
    return axios
      .post(API_URL + "/setpassword", {
        username,
        newpass,
        confirmpass
      })
      .then(response => {
        if (response.data) {
          //localStorage.setItem("crm_expo_token", JSON.stringify(response.data));
          //setAuthToken(response.data.accessToken);
        }
        return response.data;
      });
  }

   changepassword(oldpass: string, newpass: string, confirmpass: string) {
    return axios
      .post(API_URL + "/changepassword", {
        oldpass,
        newpass,
        confirmpass
      })
      .then(response => {
        if (response.data) {
          localStorage.setItem("crm_expo_token", JSON.stringify(response.data));
         setAuthToken(response.data.accessToken);
        }
        return response.data;
      });
  }

 

}

export default new UserService();